<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Ad Hoc Requests</h4>
      <p>View and manage Ad Hoc Requests</p>
    </div>
    <div class="action-container">
      <div class="form-check form-check-inline toggle request-filter-toggle">
        <input
          type="checkbox"
          class="form-check-input"
          id="showMyServiceTeamRequestsOnlySwitch"
          [(ngModel)]="showMyServiceTeamRequestsOnly"
          (change)="onShowMyServiceTeamRequestsOnlyChanged()"
        />
        <label class="form-check-label" for="showMyServiceTeamRequestsOnlySwitch">Show my service team requests only</label>
      </div>
      <div class="form-check form-check-inline toggle request-filter-toggle">
        <input
          type="checkbox"
          class="form-check-input"
          id="showApprovedRequestsOnlySwitch"
          [(ngModel)]="showApprovedRequestsOnly"
          (change)="onShowApprovedRequestsOnlyChanged()"
        />
        <label class="form-check-label" for="showApprovedRequestsOnlySwitch">Show approved requests only</label>
      </div>
      <button type="button" class="btn btn-primary" routerLink="/pf/ad-hoc-requests/create">
        Create New Request
      </button>
      <button
        *ngIf="isAdmin"
        type="button"
        class="btn btn-danger ms-2"
        [disabled]="!hasSelectedRequests"
        (click)="deleteSelectedRequests()"
      >
        Delete
      </button>
      <a
          href="javascript:void(0)"
          class="topbar-item"
          (click)="exportExcel()"
          placement="top-right"
          container="body"
          ngbTooltip="Export to Excel"
          aria-label="Export to Excel"
        >
          <span class="far fa-file-excel fa-lg"></span>
        </a>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main mt-3">
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular
      #agGrid
      id="ViewGrid"
      style="width: 100%; height: 540px"
      class="ag-theme-balham"
      [gridOptions]="gridOptions"
      [excelStyles]="headerStyle"
      [rowData]="rowData"
      [masterDetail]="true"
      [pagination]="true"
      rowSelection="multiple"
      [rowMultiSelectWithClick]="true"
      [suppressRowClickSelection]="!isAdmin"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (filterChanged)="onFilterChanged($event)"
    >
    </ag-grid-angular>
  </div>
</div>
